export const situations = ["EN COURS", "RESILIE", "ACHEVÉ"];

export const financements = [
  "ARC",
  "CERC",
  "CREDIT: IDA-7263",
  "CREDIT: IDA-7264",
  "CREDIT:7263-MG",
  "FSS FA3",
  "PFSR",
  "PSFR CREDIT IDA 7263 MG",
  "PSFR CREDIT IDA 7263-MG",
  "UNICEF",
];

export const composantes = [
  "ACT",
  "ACT POST CATA",
  "ACT-POST CATA",
  "ARC/CPGU",
  "CERC",
  "FIAVOTA",
  "FSP",
  "FSP et TMDH",
  "FSP-TMDH",
  "FSU",
  "GESTION DE PROJET",
  "INFRA",
  "INFRA-POST CATA",
  "R\u00e9ponse aux crises",
  "TMDH",
  "TMNC",
  "Transversale",
  "ZARAMIRA",
];
